import { GameOperate } from './modules/game/GameOperate';
const onVersionLoaded = () => {
    Laya.stage.frameRate = Laya.Stage.FRAME_FAST;
    GameOperate.inst.startUp();
};
const startUp = () => {
    Config.useWebGL2 = false;
    Config.isAntialias = true;
    if (typeof Laya3D !== 'undefined')
        Laya3D.init(1334, 750);
    else
        Laya.init(1334, 750, Laya.WebGL);
    Laya.stage.scaleMode = Laya.Stage.SCALE_FIXED_WIDTH;
    Laya.stage.screenMode = Laya.Stage.SCREEN_HORIZONTAL;
    Laya.stage.alignV = 'top';
    Laya.stage.alignH = 'left';
    Laya.URL.exportSceneToJson = true;
    Laya.MouseManager.multiTouchEnabled = false;
    Laya.stage.frameRate = Laya.Stage.FRAME_SLOW;
    Laya.stage.bgColor = '#FDE5FD';
    GameOperate.inst.init();
    Laya.ResourceVersion.enable(`version.json?ver=${Math.random()}`, Laya.Handler.create(this, onVersionLoaded), Laya.ResourceVersion.FILENAME_VERSION);
};
startUp();
//# sourceMappingURL=index.js.map